module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/duplex-browser.js
// module id = SDM6
// module chunks = 0 28 29 102 107 108 109 110 111 113 114 116 117 118